import { blackColors } from 'assets/jss/material-dashboard-pro-react';

const servicePickerStyle = (theme) => ({
	servicePickerWrapper: {
		width: '100%',
		display: 'flex',
		alignItems: 'center',
		overflow: 'hidden',
		padding: '20px 0',
	},
	arrowButton: {
		zIndex: 100,
		transition: 'all .1s ease-in-out',
		cursor: 'pointer',
		'& > svg': {
			width: 32,
			height: 32,
			color: blackColors[1],
		},
	},
	arrowButtonDisabled: {
		cursor: 'auto',
		'& > svg': {
			color: blackColors[5],
		},
	},
	arrowLeftButton: {
		paddingRight: 20,
		[theme.breakpoints.down('sm')]: {
			paddingRight: 5,
		},
	},
	arrowRightButton: {
		paddingLeft: 20,
		[theme.breakpoints.down('sm')]: {
			paddingLeft: 5,
		},
	},
	sliderWrapper: {
		width: 'calc(100% - 104px)',
		[theme.breakpoints.down('sm')]: {
			width: 'calc(100% - 74px)',
		},
	},
	slider: {
		display: 'flex',
		position: 'relative',
		transition: 'left 0.2s ease-in-out',
	},
	sliderWithHiddenArrows: {
		justifyContent: 'center',
	},
	hideArrows: {
		visibility: 'hidden',
	},
});

export default servicePickerStyle;
